import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-calendar-icon',
  templateUrl: './lib-calendar-icon.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LibCalendarIconComponent {}
